

































import { Prop, Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class JsonFetchAlert extends Vue {
  // data
  @Prop() private pkgJson!: any
  @Prop() private dspJson!: any

  // Lifecycle hooks
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
